export default __webpack_public_path__ + "static/Logo_navigation-09512fa133c3df393f2320b24029812a.svg";